import { createFileRoute } from '@tanstack/react-router';
import EmployeeOnboardingPage from '@/features/employee-onboarding/EmployeeOnboardingPage';

export const Route = createFileRoute('/e/employee-onboarding')({
  staticData: { hideShell: true },
  component: EmployeeOnboardingPage,
});
